<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <h1>Store's staff sign in to continue</h1>
    </div>

    <div class="login-content">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-field">
          <label class="form-field-label">Username</label>
          <input
            type="text"
            class="large-input"
            [class.error]="showErrorState('username')"
            formControlName="username"
            placeholder="Enter your username"
          >
          <div
            [@inputErrorAnimation]="showErrorState('username')"
            class="form-field-error"
          >
            Username is required
          </div>
        </div>

        <div class="form-field">
          <label class="form-field-label">Password</label>
          <input
            class="large-input"
            [class.error]="showErrorState('password')"
            type="password"
            formControlName="password"
            placeholder="Enter your password"
          >
          <div
            [@inputErrorAnimation]="showErrorState('password')"
            class="form-field-error"
          >
            Password is required
          </div>
        </div>

        <div class="error-message" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>

        <div class="login-actions">
          <app-button
            [isLoading]="isLoading"
            (onClick)="onSubmit()"
            size="large">
            Sign In
          </app-button>
        </div>
      </form>
    </div>
  </div>
</div>
